import { connect } from "react-redux";
import { useState, useEffect } from "react";
import { publicIp } from "public-ip";
import { NavLink, useNavigate } from "react-router-dom";
import { InAppTemplate } from "../../../shared/templates/inapp";
import { Formik, Form, Field, FormikProps, ErrorMessage } from "formik";
import * as Yup from "yup";
import PaymentIcon from "react-payment-icons";
import Dropdown from "react-bootstrap/Dropdown";
import Tab from "react-bootstrap/Tab";
import Nav from "react-bootstrap/Nav";
import PhoneInput from "react-phone-input-2";
import { loadStripe } from "@stripe/stripe-js";
import {
  CardElement,
  Elements,
  useStripe,
  useElements,
  PaymentElement,
  CardNumberElement,
  CardExpiryElement,
  CardCvcElement,
  ElementsConsumer,
} from "@stripe/react-stripe-js";
import { useWindowSize } from "../../../hooks/useWindowSize";
import GooglePlacesAutocomplete, {
  geocodeByPlaceId,
} from "react-google-places-autocomplete";
import "react-credit-cards/lib/styles.scss";
import Walmart from "../../../assets/icons/walmart.svg";
import MsCard from "../../../assets/ms-card.png";
import CardCta1 from "../../../assets/card-cta.png";
import LeftArrow from "../../../assets/left-arr.png";
import Bankico from "../../../assets/bankico.png";
import CardCta2 from "../../../assets/card-cta2.png";
import DownloadIco from "../../../assets/download.png";
import WithdrawalIco from "../../../assets/icons/dashboard/withdrawal.png";
import { TableComponent } from "../../../shared/components/table";
import Modal from "react-bootstrap/Modal";
import {
  storeActions,
  GetGeoCodeInfoWithPostalCode,
} from "../../../redux/actions/in-app";
import { AlertMsg } from "../../../shared/components/alert-msg";
import { LoadingItem } from "../../../shared/components/loading";
import ReactPaginate from "react-paginate";
import { appConstants } from "../../../redux/action-constants/inapp.constants";
import { allowNumbersOnly, getDateFromISO } from "../../../shared/utils";
import VerifyInfo from "./VerifyInfo";
import { AlertBanner } from "../../../shared/components/alert-banner";

const createPayoutAccAction = async ({ pageProps, payload }: any) => {
  console.log("Initiating createPayoutAccAction with payload:", payload);
  await pageProps.createPayoutAccountAction(payload);
};

const LinkExternalAccAction = async ({ pageProps, payload }: any) => {
  console.log("Initiating LinkExternalAccount with payload:", payload);
  if (typeof pageProps.LinkExternalAccountAction !== "function") {
    console.error("pageProps.LinkExternalAccountAction is not a function");
    return {
      error: "Unable to link card. Please try again or contact support.",
    };
  }
  try {
    await pageProps.LinkExternalAccountAction(payload);
    return { success: true };
  } catch (error) {
    console.error("Error in LinkExternalAccountAction:", error);
    return { error: "Failed to link card. Please try again." };
  }
};

const deactivatePayoutAcccountAction = async ({ pageProps, payload }: any) => {
  console.log(
    "Initiating deactivatePayoutAcccountAction with payload:",
    payload
  );
  await pageProps.deactivatePayoutAccount(payload);
};

const createTokenizeData = async ({ pageProps, payload, type }: any) => {
  console.log(
    "Initiating createTokenizeData with payload:",
    payload,
    "and type:",
    type
  );
  await pageProps.createTokenizeData(payload, type);
};

const getStorePayAccounts = async ({ pageProps, payload }: any) => {
  console.log("Initiating getStorePayAccounts with payload:", payload);
  await pageProps.getStorePaymentAccounts(payload);
};

const getPayoutPendingLink = async ({ pageProps, payload }: any) => {
  console.log("Initiating getPayoutPendingLink with payload:", payload);
  await pageProps.getPayoutPendingLink(payload);
};

const getStorePaymentsHistory = async ({ pageProps, payload }: any) => {
  console.log("Initiating getStorePaymentsHistory with payload:", payload);
  await pageProps.getStorePaymentsHistory(payload);
};

const CardPayoutForm = ({ stripe, elements, setCardTokenized }: any) => {
  const [cardHolder, setCardHolder] = useState<string>("");
  const [cardHolderError, setCardHolderError] = useState<boolean>(false);
  const [cardCardNumDone, setCardNumDone] = useState<boolean>(true);
  const [cardCardNumCheck, setCardNumCheck] = useState<string>("");
  const [cardCvvDone, setCardCvvDone] = useState<boolean>(true);
  const [cardCvvCheck, setCardCvvCheck] = useState<string>("");
  const [cardExpiryDone, setCardExpiryDone] = useState<boolean>(true);
  const [cardExpiryCheck, setCardExpiryCheck] = useState<string>("");

  const handleSubmit = async () => {
    console.log("CardPayoutForm handleSubmit triggered");
    if (!stripe || !elements) {
      console.error("Stripe or elements not initialized");
      return;
    }
    if (cardHolder === "" || cardHolder.length < 4) {
      setCardHolderError(true);
      console.error("Cardholder name invalid or empty:", cardHolder);
      return;
    } else {
      setCardHolderError(false);
    }

    if (cardCardNumCheck === "") {
      setCardNumDone(false);
      console.error("Card number incomplete");
      return;
    }
    if (cardCvvCheck === "") {
      setCardCvvDone(false);
      console.error("CVV incomplete");
      return;
    }
    if (cardExpiryCheck === "") {
      setCardExpiryDone(false);
      console.error("Expiry date incomplete");
      return;
    }

    const cardNumberElement = elements.getElement(CardNumberElement);
    if (!cardNumberElement) {
      console.error("Card number element not found");
      return;
    }

    try {
      const res = await stripe.createToken(cardNumberElement, {
        name: cardHolder,
        currency: "CAD",
      });
      if (res?.token) {
        setCardTokenized(res);
        console.log("Card tokenized successfully:", res.token.id);
      } else if (res?.error) {
        console.error("Stripe tokenization error:", res.error.message);
      }
    } catch (error) {
      console.error("Error during card tokenization:", error);
    }
  };

  return (
    <div className="form-wrap withdrawal-form">
      <AlertBanner
        message="Debit card withdrawals are instant"
        type="info"
        closable={false}
        animated={false}
      />

      <div className="form-group">
        <label htmlFor="">Card number</label>
        <CardNumberElement
          onChange={(event) => {
            console.log("CardNumberElement onChange:", event);
            if (event?.empty === false) {
              setCardNumCheck("card");
            } else {
              setCardNumCheck("");
            }
            if (event?.complete === true) {
              setCardNumDone(true);
            } else {
              setCardNumDone(false);
            }
          }}
          options={{
            showIcon: true,
            classes: {
              base: `card2 ${cardCardNumDone ? "" : "is-invalid-input"}`,
            },
          }}
        />
      </div>
      <div className="two-sided">
        <div className="form-group">
          <label htmlFor="">Expiration date</label>
          <CardExpiryElement
            onChange={(event) => {
              console.log("CardExpiryElement onChange:", event);
              if (event?.empty === false) {
                setCardExpiryCheck("exp");
              } else {
                setCardExpiryCheck("");
              }
              if (event?.complete === true) {
                setCardExpiryDone(true);
              } else {
                setCardExpiryDone(false);
              }
            }}
            options={{
              classes: {
                base: `card2 ${cardExpiryDone ? "" : "is-invalid-input"}`,
              },
            }}
          />
        </div>
        <div className="form-group">
          <label htmlFor="">CVV</label>
          <CardCvcElement
            onChange={(event) => {
              console.log("CardCvcElement onChange:", event);
              if (event?.empty === false) {
                setCardCvvCheck("cvv");
              } else {
                setCardCvvCheck("");
              }
              if (event?.complete === true) {
                setCardCvvDone(true);
              } else {
                setCardCvvDone(false);
              }
            }}
            options={{
              placeholder: "000",
              classes: {
                base: `card2 ${cardCvvDone ? "" : "is-invalid-input"}`,
              },
            }}
          />
        </div>
      </div>
      <div className="form-group">
        <label htmlFor="">Cardholder name</label>
        <input
          id="name"
          value={cardHolder}
          name="name"
          type="text"
          placeholder="Enter name on card"
          onChange={(e: any) => {
            console.log("Cardholder name changed:", e.target.value);
            setCardHolder(e.target.value);
            if (e.target.value.trim().length >= 4) {
              setCardHolderError(false);
            } else {
              setCardHolderError(true);
            }
          }}
          className={`input-wrap ${
            cardHolderError
              ? "is-invalid-input "
              : cardHolder !== ""
              ? "valid-input"
              : ""
          }`}
        />
        {cardHolderError && <div className="form-input-error">Required</div>}
      </div>
      <div className="payout-cta">
        <button
          disabled={
            cardHolderError ||
            !cardCardNumDone ||
            !cardCvvDone ||
            !cardExpiryDone
          }
          onClick={handleSubmit}
          className="btn"
        >
          Verify information
        </button>
      </div>
    </div>
  );
};

const CardPayoutFormWrap = ({ setCardTokenized }: any) => {
  return (
    <ElementsConsumer>
      {({ stripe, elements }) => (
        <CardPayoutForm
          setCardTokenized={setCardTokenized}
          stripe={stripe}
          elements={elements}
        />
      )}
    </ElementsConsumer>
  );
};

const CreatePayoutAccountModal = ({
  showPayoutModal,
  setShowPayoutModal,
  pageProps,
  stripePromiseInfo,
}: any) => {
  const navigate = useNavigate();
  const [payoutAccountData, setPayoutAccountData] = useState();
  const [payoutStage, setPayoutStage] = useState("acc_details");
  const [payoutType, setPayoutType] = useState<any>();
  const [newPostalCode, setNewPostalCode] = useState();
  const [postalCodeAreaData, setPostalCodeArea] = useState<any>();
  const [postalCodeAreaError, setPostalCodeAreaError] = useState<any>();
  const [extractedInfo, setExtractedInfo] = useState<any>();
  const [ownerAddress, setOwnerAddress] = useState<any>(null);
  const [ownerExtractedInfo, setOwnerExtractedInfo] = useState<any>();
  const [ownerAddressSearched, setOwnerAddressSearched] = useState<any>();
  const [storeFormInitValues, setStoreFormInitValues] = useState<any>({
    country: "Canada",
    email: "",
    addressLine1: "",
    addressLine2: "",
    city: "",
    state: "",
    phone: "",
    name: "",
    postalCode: "",
    firstName: "",
    lastName: "",
    accountHolderName: "",
  });
  const [cardtokenizedData, setCardTokenized] = useState<any>();
  const [tokenizedData, setDataToTokenize] = useState<any>();
  const [ipAddress, setIpAddress] = useState<any>();

  let tokenRequest = pageProps.createPayoutInfoTokenRequest;

  useEffect(() => {
    console.log("Initial useEffect triggered");
    getMyIp();
    createTokenizeData({ pageProps, payload: "CLEAR" });
    setStoreFormInitValues({
      country: "Canada",
      email: "",
      addressLine1: "",
      addressLine2: "",
      city: "",
      state: "",
      phone: "",
      name: "",
      postalCode: "",
      firstName: "",
      lastName: "",
      accountHolderName: "",
    });
    setOwnerAddressSearched({ label: "", value: "" });
  }, []);

  //   useEffect(() => {
  //     if (payoutAccountData) {
  //       console.log("Payout account data updated:", payoutAccountData);
  //       createPayoutAccAction({ pageProps, payload: payoutAccountData });
  //       setShowPayoutModal(false); // Close modal after submission
  //     }
  //   }, [payoutAccountData]);

  useEffect(() => {
    if (tokenizedData) {
      console.log("Tokenized data updated:", tokenizedData);
      createPayoutAccAction({ pageProps, payload: "CLEAR" });
      setOwnerAddressSearched({ label: "", value: "" });
      setStoreFormInitValues({
        country: "Canada",
        email: "",
        addressLine1: "",
        addressLine2: "",
        city: "",
        state: "",
        phone: "",
        name: "",
        postalCode: "",
        firstName: "",
        lastName: "",
        accountHolderName: tokenizedData.accountHolderName || "",
      });
      createTokenizeData({
        pageProps,
        payload: tokenizedData,
        type: payoutType,
      });
    }
  }, [tokenizedData]);

  useEffect(() => {
    if (cardtokenizedData) {
      console.log("Card tokenized data updated:", cardtokenizedData);
      createPayoutAccAction({ pageProps, payload: "CLEAR" });
    }
  }, [cardtokenizedData]);

  useEffect(() => {
    if (ownerExtractedInfo) {
      console.log("Owner extracted info updated:", ownerExtractedInfo);
      let tempStoreFormInitValues = { ...storeFormInitValues };
      tempStoreFormInitValues.city = ownerExtractedInfo?.postalCodeArea || "";
      tempStoreFormInitValues.state =
        ownerExtractedInfo?.provinceChosenFull || "";
      tempStoreFormInitValues.postalCode = ownerExtractedInfo?.postCode || "";
      tempStoreFormInitValues.addressLine1 =
        ownerExtractedInfo?.newAddress || "";
      tempStoreFormInitValues.country = ownerExtractedInfo?.country || "CA";
      setPostalCodeArea(ownerExtractedInfo?.postCode);
      setStoreFormInitValues(tempStoreFormInitValues);
      setOwnerAddressSearched({
        label: ownerExtractedInfo?.newAddress || "",
        value: ownerExtractedInfo?.newAddress || "",
      });
    }
  }, [ownerExtractedInfo]);

  useEffect(() => {
    if (newPostalCode) {
      console.log("New postal code updated:", newPostalCode);
      setPostalCodeAreaError("");
      GetGeoCodeInfoWithPostalCode(
        newPostalCode,
        extractedInfo?.topLevelArea
      ).then((res: any) => {
        console.log("GeoCodeInfo response:", res);
        let tempStoreFormInitValues = { ...storeFormInitValues };
        if (res?.status === "success" && res?.data) {
          tempStoreFormInitValues.city = res?.data;
        } else {
          setPostalCodeAreaError(res?.error);
          console.error("GeoCodeInfo error:", res?.error);
        }
        setStoreFormInitValues(tempStoreFormInitValues);
      });
    }
  }, [newPostalCode]);

  async function getMyIp() {
    let ipAddress = await publicIp();
    console.log("Fetched IP address:", ipAddress);
    setIpAddress(ipAddress);
  }

  let bankPayoutInitialValues: any = {
    accountNumber: "",
    accountHolderName: "",
    currency: "CAD",
    accountHolderType: "",
    routingNumber: "",
    institutionNumber: "",
    accountype: "",
  };

  let bankDetailsValidationSchema = Yup.object().shape({
    accountNumber: Yup.string().required("Required"),
    accountHolderName: Yup.string().required("Required"),
    routingNumber: Yup.string().required("Required"),
    institutionNumber: Yup.string().required("Required"),
    accountHolderType: Yup.string().required("Required"),
    accountype: Yup.string().required("Required"),
  });

  let extractedData: any = {};
  const handleSelectedOwnerAddress = async (
    address: any,
    setFieldValue: any
  ) => {
    console.log("handleSelectedOwnerAddress triggered with address:", address);
    setOwnerAddress(address);
    const [place] = await geocodeByPlaceId(address?.value.place_id);
    let addressMeta = place?.address_components;
    console.log("Geocode address components:", addressMeta);

    let extractedInfoFromAddress = () => {
      let streetNumber: any = "",
        streetName: any = "",
        areaName: any = "",
        postalCodeArea: any = "",
        fullAddress: any,
        topLevelArea: any,
        provinceChosenFull: any,
        provinceChosen: any,
        country: any = "";

      for (
        let componentIndex = 0;
        componentIndex < addressMeta.length;
        componentIndex++
      ) {
        if (
          addressMeta[componentIndex]?.types[0] === "postal_code" &&
          !extractedData?.postCode
        ) {
          extractedData.postCode = addressMeta[componentIndex]?.long_name;
          setFieldValue("postalCode", extractedData.postCode);
        }
        if (
          addressMeta[componentIndex]?.types[0] === "street_number" &&
          streetNumber === ""
        ) {
          streetNumber = `${addressMeta[componentIndex]?.long_name}`;
        }
        if (
          addressMeta[componentIndex]?.types[0] === "route" &&
          streetName === ""
        ) {
          streetName = `${streetNumber !== "" ? ", " : ""}${
            addressMeta[componentIndex]?.long_name
          }`;
        }
        if (
          addressMeta[componentIndex]?.types.includes("neighborhood") ||
          addressMeta[componentIndex]?.types.includes("locality") ||
          addressMeta[componentIndex]?.types.includes(
            "administrative_area_level_5"
          ) ||
          addressMeta[componentIndex]?.types.includes(
            "administrative_area_level_4"
          )
        ) {
          areaName += `${
            streetNumber !== "" || streetName !== "" || areaName !== ""
              ? ", "
              : ""
          }${addressMeta[componentIndex]?.long_name}`;
        }
        if (
          addressMeta[componentIndex]?.types.includes(
            "administrative_area_level_1"
          )
        ) {
          topLevelArea = addressMeta[componentIndex]?.long_name;
          provinceChosen = addressMeta[componentIndex]?.short_name;
          provinceChosenFull = addressMeta[componentIndex]?.long_name;
          setFieldValue("state", provinceChosenFull);
        }
        if (addressMeta[componentIndex]?.types.includes("locality")) {
          postalCodeArea = addressMeta[componentIndex]?.long_name;
          setFieldValue("city", postalCodeArea);
        }
        if (addressMeta[componentIndex]?.types.includes("country")) {
          country = addressMeta[componentIndex]?.short_name;
          setFieldValue("country", country);
        }

        fullAddress = `${streetNumber} ${streetName} ${areaName}`;
        extractedData.newAddress = fullAddress;
        extractedData.postalCodeArea = postalCodeArea;
        extractedData.topLevelArea = topLevelArea;
        extractedData.provinceChosen = provinceChosen;
        extractedData.provinceChosenFull = provinceChosenFull;
        extractedData.country = country;

        if (
          extractedData?.postCode &&
          extractedData?.newAddress &&
          extractedData?.provinceChosen &&
          extractedData?.country
        ) {
          break;
        }
      }
      console.log("Extracted address info:", extractedData);
      return extractedData;
    };
    setOwnerExtractedInfo(extractedInfoFromAddress());
  };

  return (
    <>
      <Modal
        className="payout_wrap"
        show={showPayoutModal}
        onHide={() => {
          console.log("Closing payout modal");
          setShowPayoutModal(false);
        }}
      >
        {tokenRequest.request_status !== "CREATE_PAYOUT_TOKEN_SUCCESS" &&
          !cardtokenizedData && (
            <>
              <Modal.Header closeButton>Add withdrawal method</Modal.Header>
              <Modal.Body>
                <div className="heading-help">
                  To add a withdrawal method to your account, select one of the
                  channels below and fill in the appropriate information
                </div>
                <Tab.Container defaultActiveKey="card_info">
                  <Nav className="acc_details_tabs">
                    <Nav.Item>
                      <Nav.Link eventKey="card_info">
                        Debit card
                        <span className="underline"></span>
                      </Nav.Link>
                    </Nav.Item>
                    <Nav.Item>
                      <Nav.Link eventKey="bank_info">
                        Bank transfer
                        <span className="underline"></span>
                      </Nav.Link>
                    </Nav.Item>{" "}
                  </Nav>
                  <Tab.Content className="acc_details_tabs_content">
                    <Tab.Pane eventKey="card_info">
                      <Elements stripe={stripePromiseInfo}>
                        <CardPayoutFormWrap
                          setCardTokenized={setCardTokenized}
                        />
                      </Elements>
                    </Tab.Pane>
                    <Tab.Pane eventKey="bank_info">
                      <Formik
                        initialValues={bankPayoutInitialValues}
                        validationSchema={bankDetailsValidationSchema}
                        onSubmit={(values: any) => {
                          console.log(
                            "Bank form submitted with values:",
                            values
                          );
                          setCardTokenized("");
                          let payload: any = {
                            accountNumber: values.accountNumber,
                            accountHolderName: values.accountHolderName,
                            currency: values.currency,
                            accountHolderType: parseInt(
                              values.accountHolderType
                            ),
                            routingNumber: `${values.routingNumber}-${values.institutionNumber}`,
                            accountType: parseInt(values.accountype),
                          };
                          setPayoutType("bank");
                          setDataToTokenize(payload);
                          console.log("Bank payout payload:", payload);
                        }}
                      >
                        {(props: FormikProps<any>) => {
                          const { values, touched, errors, handleChange } =
                            props;
                          return (
                            <Form>
                              <div className="form-wrap withdrawal-form">
                                <div className="form-group">
                                  <label htmlFor="accountNumber">
                                    Account number
                                  </label>
                                  <Field
                                    id="accountNumber"
                                    value={allowNumbersOnly(
                                      values.accountNumber
                                    )}
                                    name="accountNumber"
                                    type="text"
                                    placeholder="0000 000"
                                    onChange={handleChange}
                                    className={`input-wrap ${
                                      errors.accountNumber &&
                                      touched.accountNumber
                                        ? "is-invalid-input"
                                        : values.accountNumber !== ""
                                        ? "valid-input"
                                        : ""
                                    }`}
                                  />
                                  <ErrorMessage
                                    name="accountNumber"
                                    className="form-input-error"
                                    component="div"
                                  />
                                </div>
                                <div className="two-sided">
                                  <div className="form-group">
                                    <label htmlFor="routingNumber">
                                      Bank transit number
                                    </label>
                                    <Field
                                      id="routingNumber"
                                      value={allowNumbersOnly(
                                        values.routingNumber
                                      )}
                                      name="routingNumber"
                                      type="text"
                                      placeholder="00000"
                                      onChange={handleChange}
                                      className={`input-wrap ${
                                        errors.routingNumber &&
                                        touched.routingNumber
                                          ? "is-invalid-input"
                                          : values.routingNumber !== ""
                                          ? "valid-input"
                                          : ""
                                      }`}
                                    />
                                    <ErrorMessage
                                      name="routingNumber"
                                      className="form-input-error"
                                      component="div"
                                    />
                                  </div>
                                  <div className="form-group">
                                    <label htmlFor="institutionNumber">
                                      Institution number
                                    </label>
                                    <Field
                                      id="institutionNumber"
                                      value={allowNumbersOnly(
                                        values.institutionNumber
                                      )}
                                      name="institutionNumber"
                                      type="text"
                                      placeholder="000"
                                      onChange={handleChange}
                                      className={`input-wrap ${
                                        errors.institutionNumber &&
                                        touched.institutionNumber
                                          ? "is-invalid-input"
                                          : values.institutionNumber !== ""
                                          ? "valid-input"
                                          : ""
                                      }`}
                                    />
                                    <ErrorMessage
                                      name="institutionNumber"
                                      className="form-input-error"
                                      component="div"
                                    />
                                  </div>
                                </div>
                                <div className="two-sided">
                                  <div className="form-group">
                                    <label htmlFor="accountype">
                                      Account type
                                    </label>
                                    <select
                                      name="accountype"
                                      value={values.accountype}
                                      onChange={handleChange}
                                      className={`input-wrap ${
                                        errors.accountype && touched.accountype
                                          ? "is-invalid-input"
                                          : values.accountype !== ""
                                          ? "valid-input"
                                          : ""
                                      }`}
                                    >
                                      <option value="">
                                        Select account type
                                      </option>
                                      <option value="1">Savings</option>
                                      <option value="2">Checking</option>
                                    </select>
                                    <ErrorMessage
                                      name="accountype"
                                      className="form-input-error"
                                      component="div"
                                    />
                                  </div>
                                  <div className="form-group">
                                    <label htmlFor="accountHolderType">
                                      Account mode
                                    </label>
                                    <select
                                      name="accountHolderType"
                                      value={values.accountHolderType}
                                      onChange={handleChange}
                                      className={`input-wrap ${
                                        errors.accountHolderType &&
                                        touched.accountHolderType
                                          ? "is-invalid-input"
                                          : values.accountHolderType !== ""
                                          ? "valid-input"
                                          : ""
                                      }`}
                                    >
                                      <option value="">
                                        Select account mode
                                      </option>
                                      <option value="1">Individual</option>
                                      <option value="2">Company</option>
                                    </select>
                                    <ErrorMessage
                                      name="accountHolderType"
                                      className="form-input-error"
                                      component="div"
                                    />
                                  </div>
                                </div>
                                <div className="form-group">
                                  <label htmlFor="accountHolderName">
                                    Account Holder Name
                                  </label>
                                  <Field
                                    id="accountHolderName"
                                    value={values.accountHolderName}
                                    name="accountHolderName"
                                    type="text"
                                    placeholder="Account Holder Name"
                                    onChange={handleChange}
                                    className={`input-wrap ${
                                      errors.accountHolderName &&
                                      touched.accountHolderName
                                        ? "is-invalid-input"
                                        : values.accountHolderName !== ""
                                        ? "valid-input"
                                        : ""
                                    }`}
                                  />
                                  <ErrorMessage
                                    name="accountHolderName"
                                    className="form-input-error"
                                    component="div"
                                  />
                                </div>
                              </div>
                              {tokenRequest.request_status ===
                                "CREATE_PAYOUT_TOKEN_FAILURE" && (
                                <AlertMsg
                                  type="error"
                                  message={tokenRequest?.request_data.error}
                                />
                              )}
                              <div className="payout-cta">
                                <button
                                  disabled={tokenRequest?.is_request_processing}
                                  className={
                                    tokenRequest.is_request_processing
                                      ? "btn btn-disabled"
                                      : "btn"
                                  }
                                >
                                  {tokenRequest.is_request_processing
                                    ? "Please wait..."
                                    : "Verify information"}
                                </button>
                              </div>
                            </Form>
                          );
                        }}
                      </Formik>
                    </Tab.Pane>
                  </Tab.Content>
                </Tab.Container>
              </Modal.Body>
            </>
          )}

        {(tokenRequest.request_status === "CREATE_PAYOUT_TOKEN_SUCCESS" ||
          cardtokenizedData) && (
          <VerifyInfo
            pageProps={pageProps}
            payoutType={payoutType}
            tokenRequest={tokenRequest}
            cardtokenizedData={cardtokenizedData}
            storeFormInitValues={storeFormInitValues}
            ownerAddressSearched={ownerAddressSearched}
            setCardTokenized={setCardTokenized}
            createTokenizeData={createTokenizeData}
            ipAddress={ipAddress}
            handleSelectedOwnerAddress={handleSelectedOwnerAddress}
            setNewPostalCode={setNewPostalCode}
            createPayoutAccAction={createPayoutAccAction}
            setPayoutAccountData={setPayoutAccountData}
            getStorePayAccounts={getStorePayAccounts}
          />
        )}
      </Modal>
      {/* <Modal
        className="success_modal"
        show={showSuccessModal}
        onHide={() => {
          console.log("Closing success modal");
          setShowSuccessModal(false);
        }}
      >
        <Modal.Header closeButton>
          <div>{errorMessage ? "Error" : "Success"}</div>
        </Modal.Header>
        <Modal.Body>
          {errorMessage ? (
            <>
              <div className="success-message">
                Failed to add withdrawal method
              </div>
              <div className="sub-message">{errorMessage}</div>
            </>
          ) : (
            <>
              <div className="success-message">{successMessage}</div>
              <div className="sub-message">
                Your {payoutType === "bank" ? "bank account" : "card"} has been
                added to your withdrawal methods.
              </div>
            </>
          )}
        </Modal.Body>
        <Modal.Footer>
          <button
            className="btn"
            onClick={() => {
              console.log("Success modal closed by button");
              setShowSuccessModal(false);
            }}
          >
            Close
          </button>
        </Modal.Footer>
      </Modal> */}
    </>
  );
};

const InAppContent = ({ pageProps }: any) => {
  const [showInvite, setShowInviteModal] = useState(false);
  const [showPayoutModal, setShowPayoutModal] = useState(false);
  const [pageNumber, setPageNumber] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [stripePromiseInfo, setStripePromise] = useState<any>();
  const [showDeactivate, setShowDeactivate] = useState<boolean>(false);
  const screenResolution: any = useWindowSize();

  useEffect(() => {
    console.log("InAppContent useEffect triggered");
    let loggedAccountInfo: any =
      localStorage.getItem("mamiVendorXAuth") || "{}";
    loggedAccountInfo = JSON.parse(loggedAccountInfo);
    let payload = `Page=${pageNumber}&Size=${pageSize}&StoreId=${loggedAccountInfo.selectedStore.id}`;
    getStorePayAccounts({
      pageProps,
      payload,
    });
    getStorePaymentsHistory({
      pageProps,
      payload,
    });
    createPayoutAccAction({
      pageProps,
      payload: "CLEAR",
    });
    deactivatePayoutAcccountAction({
      pageProps,
      payload: "CLEAR",
    });
    createTokenizeData({
      pageProps,
      payload: "CLEAR",
    });
    getPayoutPendingLink({
      pageProps,
      payload: "CLEAR",
    });
  }, []);

  useEffect(() => {
    if (
      pageProps.deactivatePayoutAccountReducerRequest.request_status ===
      "DEACTIVATE_PAYOUT_ACCOUNT_SUCCESS"
    ) {
      console.log(
        "Deactivate payout account success:",
        pageProps.deactivatePayoutAccountReducerRequest
      );
      let loggedAccountInfo: any =
        localStorage.getItem("mamiVendorXAuth") || "{}";
      loggedAccountInfo = JSON.parse(loggedAccountInfo);
      let payload = `Page=${pageNumber}&Size=${pageSize}&StoreId=${loggedAccountInfo.selectedStore.id}`;
      setTimeout(() => {
        console.log(
          "Fetching store payment accounts after deactivate:",
          payload
        );
        getStorePayAccounts({
          pageProps,
          payload,
        });
      }, 2500);
    }
  }, [pageProps.deactivatePayoutAccountReducerRequest.request_status]);

  useEffect(() => {
    console.log("Page number or size changed:", { pageNumber, pageSize });
    let loggedAccountInfo: any =
      localStorage.getItem("mamiVendorXAuth") || "{}";
    loggedAccountInfo = JSON.parse(loggedAccountInfo);
    let payload = `Page=${pageNumber}&Size=${pageSize}&StoreId=${loggedAccountInfo.selectedStore.id}`;

    getStorePaymentsHistory({
      pageProps,
      payload,
    });
  }, [pageNumber, pageSize]);

  useEffect(() => {
    if (
      pageProps.getStorePayoutAccRequest.request_status ==
      "GET_STORE_PAY_ACCOUNTS_SUCCESS"
    ) {
      console.log(
        "Store payout accounts fetched:",
        pageProps.getStorePayoutAccRequest.request_data
      );
      const stripePromiseData = loadStripe(
        pageProps.getStorePayoutAccRequest.request_data?.publishkey
          ?.publishableKey
      );
      setStripePromise(stripePromiseData);
    }
  }, [pageProps.getStorePayoutAccRequest.request_status]);

  let detailsValidationSchema = Yup.object().shape({
    staffMail: Yup.string().required("Required"),
  });
  let initialValues: any = {
    staffMail: "",
  };

  const ReportTable = ({ reportData }: any) => {
    if (reportData?.results) {
      return (
        <>
          <thead>
            <tr>
              <th>
                {" "}
                <span>S/N</span>
              </th>
              <th>Transaction ID</th>
              <th>Date</th>
              <th>Status</th>
              <th>Amount</th>
            </tr>
          </thead>
          <tbody>
            {reportData?.results.map((eachData: any, index: any) => {
              return (
                <tr key={index}>
                  <td>
                    {" "}
                    <span>{index + 1}</span>{" "}
                  </td>
                  <td>{eachData?.vendorOrderId}</td>
                  <td>
                    {getDateFromISO({ date: eachData.createdDate }) || "N/A"}
                  </td>
                  <td>
                    <div className="txt-status success">
                      <span className="status-tick"></span>
                      {eachData?.payoutStatus}
                    </div>
                  </td>
                  <td>${eachData?.amount}</td>
                </tr>
              );
            })}
          </tbody>
        </>
      );
    }
    return <></>;
  };

  const MobileDataGrid = ({ reportData }: any) => {
    return (
      <div className="mobile-data-grid for_details">
        {reportData?.results.length >= 1 && (
          <>
            {reportData?.results.map((eachItem: any, index: any) => {
              return (
                <div className="each_data_item" key={index}>
                  <div className="main-txt-head ">
                    <div className="order_id_action">
                      <div className="id_txt">
                        {eachItem?.vendorOrderId}
                        <div className="date_item">
                          {getDateFromISO({
                            date: eachItem.createdDate,
                            returnTime: true,
                          }) || "N/A"}
                        </div>
                      </div>
                      <div className="order_cta">
                        {eachItem.payoutStatus === "Paid" && (
                          <span
                            className="order_action confirm"
                            onClick={() => {
                              console.log(
                                "Download clicked for order:",
                                eachItem?.vendorOrderId
                              );
                            }}
                          >
                            <img src={DownloadIco} />
                          </span>
                        )}
                      </div>
                    </div>{" "}
                  </div>
                  <div className="each_mobile_prod_info">
                    <div className="title-txt">Amount </div>
                    <div className="availables"> ${eachItem?.amount} </div>
                  </div>
                  <div className="each_mobile_prod_info">
                    <div className="title-txt">Status </div>
                    <div
                      className={
                        eachItem.payoutStatus === "Paid"
                          ? "availables done"
                          : "availables"
                      }
                    >
                      {eachItem.payoutStatus === "Paid" && <span></span>}{" "}
                      {eachItem.payoutStatus === "Paid"
                        ? "Successful"
                        : eachItem.payoutStatus}
                    </div>
                  </div>
                </div>
              );
            })}
          </>
        )}
      </div>
    );
  };

  const InviteStaff = () => {
    return (
      <Modal
        className="invite_staff_wrap"
        show={showInvite}
        onHide={() => {
          console.log("Closing invite staff modal");
          setShowInviteModal(false);
        }}
      >
        <Modal.Body>
          <div className="business-info">
            <img src={Walmart} alt="" />
            <div className="business-name">Walmart</div>
            <div className="sub-info">Business Account</div>
          </div>
          <div className="send-head">Send Invite Link</div>
          <Formik
            initialValues={initialValues}
            validationSchema={detailsValidationSchema}
            onSubmit={(values: any, actions) => {
              console.log("Invite staff form submitted:", values);
            }}
          >
            {(props: FormikProps<any>) => {
              const {
                values,
                touched,
                errors,
                setFieldTouched,
                handleChange,
                setFieldValue,
              } = props;
              return (
                <Form>
                  <div className="form-wrap">
                    <div className="">
                      <div className="form-group">
                        <Field
                          id="staffMail"
                          value={values.staffMail}
                          name="staffMail"
                          type="text"
                          placeholder="Staff email"
                          onChange={handleChange}
                          className={`input-wrap ${
                            errors.staffMail && touched.staffMail
                              ? "is-invalid-input "
                              : values.staffMail !== ""
                              ? "valid-input"
                              : ""
                          }`}
                        />
                        <ErrorMessage
                          name="staffMail"
                          className="form-input-error"
                          component="div"
                        />
                      </div>
                    </div>
                  </div>
                  <div className="invite-cta">
                    <button className="btn">Send Invite</button>
                  </div>
                </Form>
              );
            }}
          </Formik>
        </Modal.Body>
      </Modal>
    );
  };

  const handlePageClick = (event: any) => {
    console.log("Pagination clicked, new page:", event.selected + 1);
    setPageNumber(event?.selected + 1);
  };

  return (
    <div className="inapp-content">
      <div className="page-content setting-page">
        <div className="head-section">
          {showInvite && <InviteStaff />}
          {showPayoutModal && stripePromiseInfo && (
            <CreatePayoutAccountModal
              pageProps={pageProps}
              showPayoutModal={showPayoutModal}
              stripePromiseInfo={stripePromiseInfo}
              setShowPayoutModal={setShowPayoutModal}
            />
          )}
          <div className="page-heading">
            <h3>Account Settings</h3>
          </div>
          {screenResolution?.width >= 768 && (
            <div className="page-menus">
              <NavLink
                end
                className={({ isActive }) => (isActive ? "active-nav" : "")}
                to="/app/profile"
              >
                Store Details
              </NavLink>
              <NavLink
                end
                className={({ isActive }) => (isActive ? "active-nav" : "")}
                to="/app/profile/staff"
              >
                Staff Account
              </NavLink>
              <NavLink
                end
                className={({ isActive }) => (isActive ? "active-nav" : "")}
                to="/app/profile/withdrawal"
              >
                Withdrawal Method
              </NavLink>
            </div>
          )}
        </div>

        <div className="payout-list-wrap">
          {screenResolution?.width <= 767 && (
            <div className="page-menus">
              <NavLink
                end
                className={({ isActive }) => (isActive ? "active-nav" : "")}
                to="/app/profile"
              >
                Store Details
              </NavLink>
              <NavLink
                end
                className={({ isActive }) => (isActive ? "active-nav" : "")}
                to="/app/profile/withdrawal"
              >
                Withdrawal Method
              </NavLink>
            </div>
          )}
          {pageProps.getStorePayoutAccRequest.request_status ===
            "GET_STORE_PAY_ACCOUNTS_PENDING" && <LoadingItem />}
          {pageProps.getStorePayoutAccRequest.request_status ===
            "GET_STORE_PAY_ACCOUNTS_SUCCESS" && (
            <>
              <div className="payout-options">
                <div className="existing-payout-setups">
                  {pageProps.getStorePayoutAccRequest.request_data.response
                    ?.results &&
                    pageProps.getStorePayoutAccRequest.request_data.response
                      ?.results.length >= 1 && (
                      <>
                        {pageProps.getStorePayoutAccRequest.request_data.response?.results.map(
                          (eachAccount: any, index: any) => {
                            if (
                              eachAccount?.hasExternalAccount === false ||
                              eachAccount?.accountStatus ===
                                "required update" ||
                              eachAccount?.accountStatus === "InActive"
                            ) {
                              return (
                                <div
                                  className="each-payout-setup for-bank"
                                  key={index}
                                >
                                  <div className="left">
                                    <div className="left-top">
                                      <div className="top-txt">
                                        PENDING ACCOUNT
                                      </div>
                                    </div>
                                    <div className="left-middle">********</div>
                                    <div className="left-bottom">
                                      <div className="title-txt">
                                        Pending action
                                      </div>
                                      {!pageProps.getPayoutPendingLinkRequest
                                        ?.is_request_processing && (
                                        <div
                                          className="pending-cta"
                                          onClick={() => {
                                            let payload = {
                                              accountId: eachAccount?.id,
                                            };
                                            console.log(
                                              "Proceed now clicked for account:",
                                              payload
                                            );
                                            getPayoutPendingLink({
                                              pageProps,
                                              payload,
                                            });
                                          }}
                                        >
                                          Proceed now
                                        </div>
                                      )}
                                    </div>
                                  </div>
                                  <div className="right">
                                    <div className="account-cta">
                                      <img src={CardCta2} />
                                    </div>
                                  </div>
                                </div>
                              );
                            }

                            if (eachAccount?.accountStatus === "Created") {
                              return (
                                <div
                                  className="each-payout-setup for-bank"
                                  key={index}
                                >
                                  <div className="left">
                                    <div className="left-top">
                                      <div className="top-txt">
                                        UNDER REVIEW
                                      </div>
                                    </div>
                                    <div className="left-middle">********</div>
                                    <div className="left-bottom"></div>
                                  </div>
                                  <div className="right">
                                    <div className="account-cta">
                                      <img src={CardCta2} />
                                    </div>
                                  </div>
                                </div>
                              );
                            }

                            if (eachAccount?.accountStatus === "Active") {
                              return (
                                <>
                                  {eachAccount?.bankInfo && (
                                    <div className="each-payout-setup for-bank">
                                      {showDeactivate && (
                                        <div className="remove_account">
                                          <div className="remove_wrap">
                                            {pageProps
                                              .deactivatePayoutAccountReducerRequest
                                              .request_status !==
                                              "DEACTIVATE_PAYOUT_ACCOUNT_SUCCESS" && (
                                              <div className="confirm_remove_txt">
                                                Please confirm you want to
                                                disable{" "}
                                                <span>
                                                  **** **** ****{" "}
                                                  {eachAccount?.cardInfo?.last4}{" "}
                                                </span>
                                                as withdrawal account
                                              </div>
                                            )}
                                            {(pageProps
                                              .deactivatePayoutAccountReducerRequest
                                              .request_status ===
                                              "DEACTIVATE_PAYOUT_ACCOUNT_RESET" ||
                                              pageProps
                                                .deactivatePayoutAccountReducerRequest
                                                .request_status ===
                                                "DEACTIVATE_PAYOUT_ACCOUNT_FAILURE") && (
                                              <div className="remove_ctas">
                                                <button
                                                  className="btn back"
                                                  onClick={() => {
                                                    console.log(
                                                      "Cancel deactivate clicked"
                                                    );
                                                    setShowDeactivate(false);
                                                  }}
                                                >
                                                  Cancel
                                                </button>
                                                <button
                                                  className="btn confirm"
                                                  onClick={() => {
                                                    let loggedAccountInfo: any =
                                                      localStorage.getItem(
                                                        "mamiVendorXAuth"
                                                      ) || "{}";
                                                    loggedAccountInfo =
                                                      JSON.parse(
                                                        loggedAccountInfo
                                                      );
                                                    let payload = {
                                                      accountId:
                                                        eachAccount?.number,
                                                      storeId:
                                                        loggedAccountInfo
                                                          .selectedStore.id,
                                                    };
                                                    console.log(
                                                      "Disable account clicked with payload:",
                                                      payload
                                                    );
                                                    deactivatePayoutAcccountAction(
                                                      { pageProps, payload }
                                                    );
                                                  }}
                                                >
                                                  Disable
                                                </button>
                                              </div>
                                            )}
                                            {pageProps
                                              .deactivatePayoutAccountReducerRequest
                                              .request_status ===
                                              "DEACTIVATE_PAYOUT_ACCOUNT_PENDING" && (
                                              <div className="confirm_remove_txt">
                                                Deactivating ...
                                              </div>
                                            )}
                                            {pageProps
                                              .deactivatePayoutAccountReducerRequest
                                              .request_status ===
                                              "DEACTIVATE_PAYOUT_ACCOUNT_SUCCESS" && (
                                              <AlertMsg
                                                type="success"
                                                message={`**** **** **** ${eachAccount?.cardInfo?.last4} successfully deleted`}
                                              />
                                            )}

                                            {pageProps
                                              .deactivatePayoutAccountReducerRequest
                                              .request_status ===
                                              "DEACTIVATE_PAYOUT_ACCOUNT_FAILURE" && (
                                              <AlertMsg
                                                type="error"
                                                message={
                                                  pageProps
                                                    .deactivatePayoutAccountReducerRequest
                                                    ?.request_data.error
                                                }
                                              />
                                            )}
                                          </div>
                                        </div>
                                      )}
                                      <div className="left">
                                        <div className="left-top">
                                          <img src={Bankico} alt="" />
                                          <div className="top-txt">
                                            BANK WITHDRAWAL
                                          </div>
                                        </div>

                                        <div className="left-middle">
                                          ****{eachAccount?.bankInfo?.last4}
                                        </div>
                                        <div className="left-bottom">
                                          <div className="title-txt">
                                            Routing number
                                          </div>
                                          <div className="type-txt">
                                            {
                                              eachAccount?.bankInfo
                                                ?.routingNumber
                                            }
                                          </div>
                                        </div>
                                      </div>

                                      <div className="right">
                                        <div className="account-cta">
                                          <img src={CardCta2} />
                                        </div>
                                      </div>
                                    </div>
                                  )}
                                  {eachAccount?.cardInfo && (
                                    <div className="each-payout-setup for-card">
                                      {showDeactivate && (
                                        <div className="remove_account">
                                          <div className="remove_wrap">
                                            {pageProps
                                              .deactivatePayoutAccountReducerRequest
                                              .request_status !==
                                              "DEACTIVATE_PAYOUT_ACCOUNT_SUCCESS" && (
                                              <div className="confirm_remove_txt">
                                                Please confirm you want to
                                                disable{" "}
                                                <span>
                                                  **** **** ****{" "}
                                                  {eachAccount?.cardInfo?.last4}{" "}
                                                </span>
                                                as withdrawal account
                                              </div>
                                            )}
                                            {(pageProps
                                              .deactivatePayoutAccountReducerRequest
                                              .request_status ===
                                              "DEACTIVATE_PAYOUT_ACCOUNT_RESET" ||
                                              pageProps
                                                .deactivatePayoutAccountReducerRequest
                                                .request_status ===
                                                "DEACTIVATE_PAYOUT_ACCOUNT_FAILURE") && (
                                              <div className="remove_ctas">
                                                <button
                                                  className="btn back"
                                                  onClick={() => {
                                                    console.log(
                                                      "Cancel deactivate clicked for card"
                                                    );
                                                    setShowDeactivate(false);
                                                  }}
                                                >
                                                  Cancel
                                                </button>
                                                <button
                                                  className="btn confirm"
                                                  onClick={() => {
                                                    let loggedAccountInfo: any =
                                                      localStorage.getItem(
                                                        "mamiVendorXAuth"
                                                      ) || "{}";
                                                    loggedAccountInfo =
                                                      JSON.parse(
                                                        loggedAccountInfo
                                                      );
                                                    let payload = {
                                                      accountId:
                                                        eachAccount?.number,
                                                      storeId:
                                                        loggedAccountInfo
                                                          .selectedStore.id,
                                                    };
                                                    console.log(
                                                      "Disable card account clicked with payload:",
                                                      payload
                                                    );
                                                    deactivatePayoutAcccountAction(
                                                      { pageProps, payload }
                                                    );
                                                  }}
                                                >
                                                  Disable
                                                </button>
                                              </div>
                                            )}
                                            {pageProps
                                              .deactivatePayoutAccountReducerRequest
                                              .request_status ===
                                              "DEACTIVATE_PAYOUT_ACCOUNT_PENDING" && (
                                              <div className="confirm_remove_txt">
                                                Deactivating ...
                                              </div>
                                            )}
                                            {pageProps
                                              .deactivatePayoutAccountReducerRequest
                                              .request_status ===
                                              "DEACTIVATE_PAYOUT_ACCOUNT_SUCCESS" && (
                                              <AlertMsg
                                                type="success"
                                                message={`**** **** **** ${eachAccount?.cardInfo?.last4} successfully deleted`}
                                              />
                                            )}

                                            {pageProps
                                              .deactivatePayoutAccountReducerRequest
                                              .request_status ===
                                              "DEACTIVATE_PAYOUT_ACCOUNT_FAILURE" && (
                                              <AlertMsg
                                                type="error"
                                                message={
                                                  pageProps
                                                    .deactivatePayoutAccountReducerRequest
                                                    ?.request_data.error
                                                }
                                              />
                                            )}
                                          </div>
                                        </div>
                                      )}
                                      <div className="db-card-top">
                                        <div className="card-brand">
                                          {eachAccount?.cardInfo?.brand && (
                                            <PaymentIcon
                                              id={eachAccount?.cardInfo?.brand.toLowerCase()}
                                              style={{ width: 40 }}
                                              className="payment-icon"
                                            />
                                          )}
                                        </div>
                                        <div className="account-cta">
                                          <Dropdown align="end">
                                            <Dropdown.Toggle
                                              id="dropdown-basic"
                                              className=""
                                            >
                                              <img src={CardCta1} />
                                            </Dropdown.Toggle>
                                            <Dropdown.Menu>
                                              <Dropdown.Item
                                                onClick={() => {
                                                  console.log(
                                                    "Disable account dropdown clicked"
                                                  );
                                                  setShowDeactivate(true);
                                                }}
                                                className=""
                                              >
                                                {" "}
                                                Disable account
                                              </Dropdown.Item>
                                            </Dropdown.Menu>
                                          </Dropdown>
                                        </div>
                                      </div>
                                      <div className="card-num">
                                        **** **** ****{" "}
                                        {eachAccount?.cardInfo?.last4}
                                      </div>
                                      <div className="other-card-info">
                                        <div className="left">
                                          <div className="title">Name</div>
                                          <div className="info-detail">
                                            {eachAccount?.cardInfo?.name}
                                          </div>
                                        </div>
                                        <div className="right">
                                          <div className="title">
                                            EXPIRY DATE
                                          </div>
                                          <div className="info-detail">
                                            {eachAccount?.cardInfo?.expMonth}/
                                            {eachAccount?.cardInfo?.expYear}
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  )}
                                </>
                              );
                            }
                            return <div key={index}></div>;
                          }
                        )}
                      </>
                    )}
                  <div
                    className="each-payout-setup add-withwrawal-cta"
                    onClick={() => {
                      console.log("Add withdrawal method clicked");
                      setShowPayoutModal(true);
                    }}
                  >
                    <div className="inner">
                      <img src={WithdrawalIco} />
                      <div className="withdrawal-txt">
                        Add a withdrawal method
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              {pageProps.getPayoutPendingLinkRequest.request_status ===
                "GET_PAYOUT_PENDING_LINK_FAILURE" && (
                <div className="pending-cta with-error">
                  {pageProps.getPayoutPendingLinkRequest?.request_data.error}
                </div>
              )}
              {pageProps.getPayoutPendingLinkRequest?.is_request_processing && (
                <div className="pending-cta ongoing">Please wait ...</div>
              )}
              <div className="payout-table">
                {pageProps.getStorePaymentsHistoryRequest.request_status ===
                  "GET_STORE_PAYMENT_HISTORY_PENDING" && <LoadingItem />}
                {pageProps.getStorePaymentsHistoryRequest.request_status ===
                  "GET_STORE_PAYMENT_HISTORY_SUCCESS" && (
                  <>
                    <div className="heading_payout_txtn">
                      <div className="main">Payment history</div>
                      <div className="other">
                        View your withdrawal history to stay on top of your
                        finances and track customer spending
                      </div>
                    </div>
                    {screenResolution?.width >= 768 && (
                      <TableComponent
                        childComponent={
                          <ReportTable
                            reportData={
                              pageProps.getStorePaymentsHistoryRequest
                                .request_data.response
                            }
                          />
                        }
                      />
                    )}
                    {screenResolution?.width <= 767 && (
                      <MobileDataGrid
                        reportData={
                          pageProps.getStorePaymentsHistoryRequest.request_data
                            .response
                        }
                      />
                    )}

                    {pageProps?.getStorePaymentsHistoryRequest?.request_data
                      ?.response?.totalNumberOfRecords > pageSize && (
                      <ReactPaginate
                        breakLabel="..."
                        nextLabel=">"
                        onPageChange={handlePageClick}
                        pageRangeDisplayed={4}
                        forcePage={pageNumber - 1}
                        className="pagination_items"
                        pageClassName="page_num"
                        pageLinkClassName="page_link"
                        activeClassName="active_page_link"
                        previousClassName="previous_page_link"
                        nextClassName="next_page_link"
                        pageCount={
                          pageProps?.getStorePaymentsHistoryRequest
                            ?.request_data?.response?.totalNumberOfPages
                        }
                        previousLabel="<"
                        renderOnZeroPageCount={null}
                      />
                    )}
                  </>
                )}
                {pageProps.getStorePaymentsHistoryRequest.request_status ===
                  "GET_STORE_PAYMENT_HISTORY_FAILURE" && (
                  <AlertMsg
                    type="error"
                    message={
                      pageProps.getStorePaymentsHistoryRequest?.request_data
                        .error
                    }
                  />
                )}
              </div>
            </>
          )}

          {pageProps.getStorePayoutAccRequest.request_status ===
            "GET_STORE_PAY_ACCOUNTS_FAILURE" && (
            <AlertMsg
              type="error"
              message={pageProps.getStorePayoutAccRequest?.request_data.error}
            />
          )}
        </div>
      </div>
    </div>
  );
};

const Withdrawal = (pageProps: any) => {
  return (
    <InAppTemplate
      pageHeadingTitle="Withdrawal Settings"
      childComponent={<InAppContent pageProps={pageProps} />}
    />
  );
};

const mapDispatchToProps = {
  LinkExternalAccountAction: storeActions.LinkExternalAccount,
  createPayoutAccountAction: storeActions.CreatePayoutAccount,
  getStorePaymentAccounts: storeActions.GetStorePaymentAccount,
  deactivatePayoutAccount: storeActions.DeactivatePayoutAccount,
  createTokenizeData: storeActions.CreateTokenizeData,
  getPayoutPendingLink: storeActions.GetPayoutPendingLink,
  getStorePaymentsHistory: storeActions.GetStorePaymentsHistory,
};

const mapStateToProps = (state: any) => ({
  linkExternalAccountRequest:
    state.allProductReducers.linkExternalAccountReducer,
  createStorePayoutRequest: state.allProductReducers.createStorePayoutReducer,
  getStorePayoutAccRequest: state.allProductReducers.getStorePayoutAccReducer,
  createPayoutInfoTokenRequest:
    state.allProductReducers.createPayoutInfoTokenReducer,
  deactivatePayoutAccountReducerRequest:
    state.allProductReducers.deactivatePayoutAccountReducer,
  getPayoutPendingLinkRequest:
    state.allProductReducers.getPayoutPendingLinkReducer,
  getStorePaymentsHistoryRequest:
    state.allProductReducers.getStorePaymentsHistoryReducer,
});

export default connect(mapStateToProps, mapDispatchToProps)(Withdrawal);
